import React, { useEffect, useState } from 'react';
import { client } from 'cccisd-apollo';
import Loader from 'cccisd-loader';
import myEmployeeQuery from './myEmployee.graphql';
import selfQuery from './self.graphql';
import SickTimeTable from './sick-time-table';

const Body = ({ self = false, employeeId = undefined }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [user, setUser] = useState();
    const [year, setYear] = useState();
    const [sickAvailable, setSickAvailable] = useState();
    const [sickCap, setSickCap] = useState();
    const [sickCarryover, setSickCarryover] = useState();
    const [sickTimeList, setSickTimeList] = useState();

    useEffect(() => {
        getSickTime();
    }, []);

    const getSickTime = async () => {
        const query = self ? selfQuery : myEmployeeQuery;

        const response = await client.query({
            query,
            fetchPolicy: 'network-only',
            variables: { employeeId },
        });

        const { selfEmployee } = response.data.timeTracker;
        setUser(self ? selfEmployee.user : selfEmployee.myEmployee.user);
        setYear(self ? selfEmployee.pto.thisYear : selfEmployee.myEmployee.pto.thisYear);
        setSickAvailable(self ? selfEmployee.sickAvailable : selfEmployee.myEmployee.sickAvailable);
        setSickCap(self ? selfEmployee.sickCap : selfEmployee.myEmployee.sickCap);
        setSickCarryover(self ? selfEmployee.pto.sickCarryover : selfEmployee.myEmployee.pto.sickCarryover);
        setSickTimeList(self ? selfEmployee.ptoList : selfEmployee.myEmployee.ptoList);

        setIsLoading(false);
    };

    return (
        <Loader type="inline" loading={isLoading} removeChildren>
            <SickTimeTable
                year={year}
                user={user}
                sickAvailable={sickAvailable}
                sickCap={sickCap}
                sickCarryover={sickCarryover}
                sickTimeList={sickTimeList}
            />
        </Loader>
    );
};

export default Body;
